import React, { useState } from 'react'
import { Route, Routes, Navigate } from 'react-router-dom'

import { Navbar, Feed, PinDetail, Search, CreatePin } from '../components'

const Pins = (user) => {
  const [searchTerm, setSearchTerm] = useState('')

  return (
    <div className='px-2 md:px-5'>
      <div className="bg-gray-50 dark:bg-slate-900">
        <Navbar searchTerm={searchTerm} setSearchTerm={setSearchTerm} user={user} />
        <div>
          <Routes>
            <Route path="/" element={<Feed />} />
            <Route path='/category/:categoryId' element={<Feed />} />
            <Route path="/pin-detail/:pinId" element={<PinDetail user={user} />} />
            <Route
              path="/create-pin"
              element={user ? <CreatePin user={user} /> : <Navigate to="/login" />}
            />
            <Route path="/search" element={<Search searchTerm={searchTerm} setSearchTerm={setSearchTerm} />} />
          </Routes>
        </div>
      </div>
    </div>
  )
}

export default Pins